import { Injectable, signal } from '@angular/core';

let idSequence = 0;

/**
 * Tracks which single SearchableSelectComponent instance is open at a time.
 * When one dropdown opens, this automatically coordinates closing any other open dropdown.
 */
@Injectable({ providedIn: 'root' })
export class SearchableSelectCoordinatorService {
    private readonly activeId = signal<number | null>(null);

    nextId(): number {
        return ++idSequence;
    }

    isOpen(id: number): boolean {
        return this.activeId() === id;
    }

    toggle(id: number): void {
        this.activeId.update((current) => (current === id ? null : id));
    }

    close(id: number): void {
        this.activeId.update((current) => (current === id ? null : current));
    }

    closeAll(): void {
        this.activeId.set(null);
    }
}
